import { render } from "./categorie_form.vue?vue&type=template&id=145fe582&scoped=true"
import script from "./categorie_form.vue?vue&type=script&lang=js"
export * from "./categorie_form.vue?vue&type=script&lang=js"

import "../../assets/css/modal.css?vue&type=style&index=0&id=145fe582&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145fe582"]])

export default __exports__